import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  NativeSelect,
  TextField,
  Typography,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { blue } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Axios from "axios";
import { EncryptStorage } from "encrypt-storage";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Loading from "../../../pages/Loading";
import FileUpload from "../Components/FileUpload";
import ShowNoteComponent from "./ShowNoteComponent";
import CreateTravelAward from "./TravelAwardModal/Create";
import DeleteTravelAward from "./TravelAwardModal/Delete";
import EditTravelAward from "./TravelAwardModal/Edit";
import { debounce } from "lodash";
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Position from "../../../modules/CustomizeComponent/PositionIcon";
import TextInputField from "../../../../_metronic/layout/components/InputFields";
import { Create } from "@material-ui/icons";
import GreenCheckBadge from "../Components/Badge";
import SortTableHeader from "../Components/SortTableHeader";
const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function createData(desc, asset, debt, client_sp, spouse_sp, net_val) {
  return {
    desc,
    asset,
    debt,
    client_sp,
    spouse_sp,
    net_val,
    details: [
      {
        addr: "Lorem Ipsum Address",
        county: "11091700",
        fair: 3,
        liens: 4,
        property: 5,
        notes: "Lorem Ipsum",
      },
    ],
  };
}



function TravelAwardBenefitsRow(props) {
  const { row, client_case_id, setAwards } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  useEffect(() => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  }, []);

  const handleChange = debounce(async (property, value) => {
    try {
      if (value && value._isAMomentObject) {
        const date_dt = new Date(value);
        const new_date = new Date(
          date_dt.getFullYear(),
          date_dt.getMonth(),
          date_dt.getDate(),
          10,
          56,
          0
        );
        row[property] = new_date;
      } else {
        row[property] = value;
      }

      const response = await Axios.put(
        `api/estate/award/${row.id}`,
        row
      );

      if (response && response.status === 200) {
        setAwards(response.data.data);
      }
    } catch (err) {
      console.error("Error updating property:", err);
    }
  }, 500); 
 
  const positions = [
    "Husband",
    "Wife",
    "Joint",
    "Client",
    "Spouse",
    "Third Party",
    "Other"
  ]; 

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
          {row.name ?? ""} {row.account_number} <Position position ={row.position}/>
        </TableCell>
          <TableCell align="left" className="font-weight-normal">
            ${row.value ?? ""} as of ({moment(row.value_date).format("L")})
          </TableCell>
          <TableCell align="left" className="font-weight-normal">
            ${row.client_sp ?? ""}
          </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.spouse_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.net_value ?? ""}
        </TableCell>
        <TableCell align="left"> 
          <ShowNoteComponent row={row} api='api/estate/award'/>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeleteTravelAward row={row} setAwards={setAwards} />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload row={row} client_case_id={client_case_id} source={'travel-award-benefits'}/>
          </div>
           <GreenCheckBadge show={row.client_sp > 0 || row.spouse_sp > 0}/>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name of Airline, Hotel :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.name} onChange={(e) => handleChange('name', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Account # :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.account_number} onChange={(e) => handleChange('account_number', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      # of Miles or Points :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.miles_val} onChange={(e) => handleChange('miles_val', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal d-flex align-center border-0 m-0 p-0" > 
                      <div>
                       <TextInputField
                        defaultValue={row.value}
                        onChange={(e) => handleChange('value', e.target.value)}
                      />
                      </div>
                      <div className="pt-3 px-5">
                      <Typography variant="p">as of</Typography> 
                      </div>
                      <div>
                      <MuiPickersUtilsProvider utils={MomentUtils}> 
                      <KeyboardDateTimePicker
                              disableToolbar
                              variant="inline"
                              format="MM/DD/yyyy"  
                              className="m-0"
                              id="date-picker-inline"
                              onChange={(value_date) => handleChange('value_date', value_date)}
                              value={new Date(row.value_date)} 
                              KeyboardButtonProps={{
                                  'aria-label': 'change date',
                              }}
                            />
                      </MuiPickersUtilsProvider>
                      </div> 
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Client SP:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.client_sp} onChange={(e) => handleChange('client_sp', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Spouse SP :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.spouse_sp} onChange={(e) => handleChange('spouse_sp', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Net Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.net_value} disabled={true} /> 
                    </ListItemSecondaryAction>
                  </ListItem> 
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name/Control of:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                      <NativeSelect
                          className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                          inputProps={{
                            name: 'positions',
                          }}
                        //  defaultValue={formik.values.type}
                          onChange={(e) => handleChange('position', e.target.value)} 
                          defaultValue={row.position}
                        >
                        {
                          positions.map((position, index) => {
                            return (
                              <option key={index} value={position}>{position}</option>
                            )
                          })
                        } 
                        </NativeSelect>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function TravelAwardBenefits(props) {
  const {handleOpen} = props;
  const encryptStorage = new EncryptStorage("secret-key");
  const decypt_data = encryptStorage.getItem("case_details");
  const client_case_id = decypt_data ? decypt_data.case.id : null;
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(false);
    const [order, setOrder]                 = useState('desc');
    const [orderBy, setOrderBy]             = useState('id');
    const headCells = [
      {
        id: 'name',
        numeric: false,
        disablePadding: true,
        label: 'Description',
      },
      {
        id: 'value',
        numeric: true,
        disablePadding: true,
        label: 'Value',
      },  
      {
        id: 'client_sp',
        numeric: true,
        disablePadding: false,
        label: 'Client SP',
      },
      {
        id: 'spouse_sp',
        numeric: true,
        disablePadding: false,
        label: 'Spouse SP',
      },
      {
        id: 'net_value',
        numeric: true,
        disablePadding: false,
        label: 'Net Value',
      },
      {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
      },
    ];
  
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc'; 
      var newValue = sortByProperty(awards, property, isAsc ? 'desc' : 'asc');
  
      setAwards(newValue);
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    function sortByProperty(arr, prop, order = "asc") {
      return [...arr].sort((a, b) => {
        let valA = a[prop];
        let valB = b[prop];
  
        // Handle dates
        if (Date.parse(valA) && Date.parse(valB)) {
          valA = new Date(valA);
          valB = new Date(valB);
        }
  
        if (valA < valB) return order === "asc" ? -1 : 1;
        if (valA > valB) return order === "asc" ? 1 : -1;
        return 0;
      });
    }
  const fetch_data = () => {
    setLoading(true);
    Axios.get("api/estate/award/" + client_case_id)
      .then((res) => {
        setAwards(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetch_data();
  }, []);

  return (
    <>
      <div id="real-property" className={`card h-100 card-custom `}>
        {/* <div className="card-header border-0 mt-3">
          <h3 class="card-title align-items-start flex-column align-self-center">
            <span class="card-label font-weight-bolder text-dark">
              Travel Award Benefits
            </span>
            <span class="text-muted mt-0 font-weight-bold font-size-sm">
              Miles & points for frequent flyers, travelers, credit card use,
              etc.
            </span>
          </h3>
        </div>
        <hr /> */}    
        <div className="d-flex px-9 align-items-center">
            <div className="ml-auto">
              <CreateTravelAward
                setAwards={setAwards}
                client_case_id={client_case_id}
                handleOpen={handleOpen}
              />
            </div>
          </div>
        <div className="pb-10 pl-10 pr-10 pt-0">
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                        <SortTableHeader 
                          headCells={headCells} 
                          order={order}
                          orderBy={orderBy} 
                          onRequestSort={handleRequestSort}
                          rowCount={awards.length}/>
              <TableBody>
                {awards.map((row) => (
                  <TravelAwardBenefitsRow
                    key={row.id}
                    row={row}
                    setAwards={setAwards}
                    client_case_id={client_case_id}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {loading && <Loading />}
      </div>
    </>
  );
}

export default TravelAwardBenefits;
